import React from "react";
import PortfolioItemPresenter from "./PortfolioItemPresenter";

const PortfolioItemContainer = props => {
  return <PortfolioItemPresenter {...props} />;
};

export default PortfolioItemContainer;
